import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Checkbox,
  Tooltip,
  Button,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import previewImg from "../../assets/icons/preview.png";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";

import PeopleIcon from "@mui/icons-material/People";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import PlaylistAddCheckCircleOutlinedIcon from '@mui/icons-material/PlaylistAddCheckCircleOutlined';

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_ALL_GROUP_PERMISSIONS_QUERY, GET_GROUP_DATA_BY_ID } from "../../graphQL/group_qry";

import {
  STAFF_CLIENT_LIST_QUERY,
} from "../../graphQL/client_qry";
import {
  GET_USER_DATA_BY_USERNAME,
} from "../../graphQL/register_qry";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

const transformPermissions = (data) => {  
  return data.map((mod) => {
    
    return {
      ...mod,
      modulepage: mod.modulepage.map((page) => {

        
        const action = mod.groupModulepageAction.find(
          (a) => parseInt(a.modulepageId) === parseInt(page.modulepageId)
        );

        const parsePermissions = (names, values) => {
          if (!names) return [];
          return names.split("|").map((name) => ({
            permission: name.trim(),
            checked: values?.includes(`${name}:1`) || false,
          }));
        };

        return {
          ...page,
          permission: page.name,
          access: action?.access || false,
          common: parsePermissions(
            page.actionCommonName,
            action?.actionCommonPermission || ""
          ),
          additional: parsePermissions(
            page.actionAdditionalName,
            action?.actionAdditionalPermission || ""
          ),
        };
      }),
    };
  });
};

const extractCommonHeaders = (data) => {
  //removes repeated values automatically by using a Set
  const headerSet = new Set();
  data.forEach((mod) => {
    
    mod.modulepage.forEach((page) => {
      if (page.actionCommonName) {
        page.actionCommonName.split("|").forEach((perm) => {
          headerSet.add(perm.trim());
        });
      }
    });
  });
  return Array.from(headerSet);
};


function UserGroupPermissions() {
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const { userId } = useParams();

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [tenantClientList, setTenantClientList] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { groupUuid } = useParams();

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [groupsAccess, setGroupsAccess] = useState(true);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };
  
  const [groupName, setGroupName] = useState(""); 
  const [clientName, setClientName] = useState("");
  const [modulesPermissions, setModulesPermissions] = useState([]); 
  const [commonHeaders,setCommonHeaders] = useState([]);

  const classes = useStyles();

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {         
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');      
      
      if(additionalActions.find(a => a == "Groups")){
        setGroupsAccess(true);}
      else {
        setGroupsAccess(false);
      }     
    }
    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
         }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME, {
    fetchPolicy: "network-only",
  });
  
  useEffect(() => {
    (() => getUserData())();
  }, [userId]);
  
  const getUserData = async () => {
    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: userId },
    });

    if (userData && !userData.getUserDataByUsername) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      userData &&
      userData.getUserDataByUsername &&
      userData.getUserDataByUsername == null
    ) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setLoadContent(true);
      setFirstName(userData.getUserDataByUsername.firstName);
      setLastName(userData.getUserDataByUsername.lastName);
      setLoadData(true);
      console.log("load page");
    }

    if (
      userDataError &&
      userDataError.graphQLErrors &&
      userDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };
  
  const [getGroupData] = useManualQuery(GET_GROUP_DATA_BY_ID, {
    fetchPolicy: "network-only",
  });
  const getGroup = async () => {
    if (groupUuid) {
      // Get group information
      const {
        loading: groupDataLoading,
        error: groupDataError,
        data: groupData,
      } = await getGroupData({
        variables: { groupUuid: groupUuid },
      });

      if (groupData.getGroupDataById == null)
      {
        navigate(`${project_url}/tenant/dashboard`)
      }
      if (!groupDataLoading && groupData && groupData.getGroupDataById) {                
        setGroupName(groupData.getGroupDataById.name);
        setClientName(groupData.getGroupDataById.clientId.name);                        
      }
      if (
        groupDataError &&
        groupDataError.graphQLErrors &&
        groupDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };
  useEffect(() => {
    (() => getGroup())();
  }, []);
  
  const [getGroupPermissionsData] = useManualQuery(GET_ALL_GROUP_PERMISSIONS_QUERY, {
    fetchPolicy: "network-only",
  });
  const getGroupPermissions = async () => {    
    if (groupUuid) {
      // Get group permission information
      const {
        loading: groupPermissionDataLoading,
        error: groupPermissionDataError,
        data: groupPermissionData,
      } = await getGroupPermissionsData({
        variables: { groupUuid: groupUuid },
      });
      if (!groupPermissionDataLoading && groupPermissionData && groupPermissionData.getAllGroupPermissions) { 
            console.log(groupPermissionData.getAllGroupPermissions);
            setModulesPermissions(transformPermissions(groupPermissionData.getAllGroupPermissions));
            setCommonHeaders(extractCommonHeaders(groupPermissionData.getAllGroupPermissions));
          }
      if (
        groupPermissionDataError &&
        groupPermissionDataError.graphQLErrors &&
        groupPermissionDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };
  useEffect(() => {
    (() => getGroupPermissions())();
  }, []);  
  
  const cellStyle = { borderRight: "1px solid #ccc" };
  const cellStyleAdditional = {
    borderRight: "1px solid #ccc",
    textAlign: "left",
  };
  
  const flatRows = modulesPermissions.flatMap((mod) =>    
    mod.modulepage.map((p, index) => ({
      moduleId: mod.moduleId,
      moduleName: mod.name,
      page: p,
      pageCount: mod.modulepage.length,
      isFirstPage: index === 0,
    }))
  );
  
  if (loadContent && loadData)
    if (groupsAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: firstName + " " + lastName, link: null },
            { label: "Staff Groups", link: `${project_url}/staff/${userId}/groups/` },
            { label: groupName, link: null }
          ]}
        />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Group Permissions
            </Typography>
          </Box>
          <Divider />
          <Box pt={2} style={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography style={{ paddingRight: 5 }} variant="h3">
              <strong>Staff:</strong> {firstName} {lastName}
            </Typography>
          </Box>
          <Box pt={2} style={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography style={{ paddingRight: 5 }} variant="h3">
              <strong>Client:</strong> {clientName}
            </Typography>
          </Box>
          <Box pt={2} style={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography style={{ paddingRight: 5 }} variant="h3">
              <strong>Group:</strong> {groupName}
            </Typography>
            <Box pl={1}>
            </Box>
          </Box>
          <TableContainer
          component={Paper}
          elevation={0}
          sx={{ border: "1px solid #e0e0e0", boxShadow: "none" }}
          >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell rowSpan={2} sx={cellStyle} align="center">
                  <strong>Module</strong>
                </TableCell>
                <TableCell rowSpan={2} sx={cellStyle} align="center">
                  <strong>Page</strong>
                </TableCell>
                <TableCell
                  colSpan={commonHeaders.length}
                  align="center"
                  sx={cellStyle}
                >
                  <strong>Common Permissions</strong>
                </TableCell>
                <TableCell rowSpan={2} align="center">
                  <strong>Additional Permissions</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                {commonHeaders.map((perm) => (
                  <TableCell key={perm} align="center" sx={cellStyle}>
                    <strong>{perm}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {flatRows.map((row) => (
                <TableRow key={`${row.moduleId}-${row.page.modulepageId}`}>
                  {row.isFirstPage && (
                    <TableCell rowSpan={row.pageCount} sx={cellStyle}>
                      {row.moduleName}
                    </TableCell>
                  )}
                  <TableCell sx={cellStyle}>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        size="small"
                        disabled
                        checked={row.page.access}
                      />
                      {row.page.permission}
                    </Box>
                  </TableCell>

                  {commonHeaders.map((perm) => (
                    <TableCell key={perm} align="center" sx={cellStyle}>                      
                      <Checkbox
                        size="small"
                        disabled
                        checked={
                          row.page.common.find((c) => c.permission === perm)
                            ?.checked || false
                        }
                      />
                    </TableCell>
                  ))}
                  <TableCell align="center">
                    {row.page.additional.length === 0 ? (
                      <>None</>
                    ) : (
                      row.page.additional.map((perm) => (
                        <Box
                          key={perm.permission}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            size="small"
                            disabled
                            checked={perm.checked}
                          />
                          {perm.permission}
                        </Box>
                      ))
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </TableContainer>
          <Box mt={4} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={() => navigate(`${project_url}/staff/${userId}/groups/`)}
            >
              OK
            </Button>
          </Box>
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default UserGroupPermissions;
